{
  "queryName": "incompleteRecords",
  "queryParam": null,
  "fields": ["id", "name", "createdAt", "type", "incomplete"]
}
